import TumengAd from './src/index.vue'

TumengAd.install = function(Vue) {
  Vue.component(TumengAd.name, TumengAd)
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(TumengAd)
}

export default TumengAd
